const routes = [
  {
    path:      '/facturacion-estado-factura',
    name:      'EstadoFactura',
    component: () => import('@/views/dashboards/facturacion/FacturacionEstadoFactura.vue'),
    meta: { title: 'Facturas por estado',      categoria: 'Facturación y pagos', icono: 'receipt' }
  },
  {
    path:      '/facturacion-forma-pago',
    name:      'FacturacionFormaPago',
    component: () => import('@/views/dashboards/facturacion/FacturacionFormaPago.vue'),
    meta: { title: 'Forma de pago',  categoria: 'Facturación y pagos', icono: 'payments' }
  },
/*  
  {
    path:      '/agrupados-por-aseguradora',
    name:      'AgrupadosAseguradora',
    component: () => import('@/views/dashboards/facturacion/AgrupadosAseguradora.vue'),
    meta: { title: 'Pagos por aseguradora',    categoria: 'Facturación y pagos', icono: 'building-bank' }
  },
  {
    path:      '/ingresos-por-periodo',
    name:      'IngresosPorPeriodo',
    component: () => import('@/views/dashboards/facturacion/IngresosPorPeriodo.vue'),
    meta: { title: 'Ingresos por período',     categoria: 'Facturación y pagos', icono: 'chart-line', nuevo: true }
  },
  {
    path:      '/saldos-pendientes',
    name:      'SaldosPendientes',
    component: () => import('@/views/dashboards/facturacion/SaldosPendientes.vue'),
    meta: { title: 'Saldos pendientes',        categoria: 'Facturación y pagos', icono: 'clock-dollar', nuevo: true }
  },
*/
]

export { routes }